let $collapsibleTriggers

export function init(elements, callback) {
    $collapsibleTriggers = jQuery(elements)

    $collapsibleTriggers.on('click', (e) => {
        e.preventDefault()
        console.log(e)

        let targetID = jQuery(e.target).attr('target')
            , $target = jQuery(`#${targetID}`)

        $target.find('article').toggleClass('open')

        typeof callback === 'function' && callback()
    })
}